import { ICheckoutItem, IOption, IProduct, MenuOptions, ProductAvailabilityItem } from 'types';
import { translations } from 'translations/en';

export const productDropdownOptions = [
  { label: 'Go to Shop', key: MenuOptions.GoToShop, danger: false },
  { label: 'Message seller', key: MenuOptions.Message, danger: false },
  { label: 'Report', key: MenuOptions.Report, danger: true },
  { label: 'Edit item', key: MenuOptions.Edit, danger: false },
  { label: 'Delete item', key: MenuOptions.Delete, danger: true },
];

export const getQuantityDropdownOptions = (quantity: number) => {
  const options: IOption[] = [];

  for (let i = 1; i <= quantity; i++) {
    options.push({ label: i.toString(), value: i.toString() });
  }

  return options;
};

export const parseToCheckoutItem = (
  product: IProduct,
  quantity: number,
  customization: { images: string[]; text: string },
): ICheckoutItem => {
  const {
    id,
    title,
    originalPrice,
    currencyCode,
    currencySymbol,
    price,
    isDigital,
    images,
    convertedFromPrice,
  } = product;

  const customizationRequest =
    customization.text || customization.images.length > 0 ? customization : null;

  const itemOriginalPrice = { currencySymbol, value: originalPrice * quantity, currencyCode };

  const itemPrice = { currencySymbol, value: price * quantity, currencyCode };

  const itemConvertedFromPrice = convertedFromPrice
    ? {
        value: convertedFromPrice.value * quantity,
        currencySymbol: convertedFromPrice.currencySymbol,
        currencyCode: convertedFromPrice.currencyCode,
      }
    : null;

  return {
    id,
    cartItemId: null,
    title,
    price: itemPrice,
    originalPrice: itemOriginalPrice,
    customizationRequest,
    convertedFromPrice: itemConvertedFromPrice,
    quantity,
    isDigital,
    image: images[0] || '',
    status: ProductAvailabilityItem.Available,
  };
};

export const getQuantityText = (quantity: number) => {
  if (quantity === 3) {
    return translations.SPECIFIC_PRODUCT.ONLY_THREE_LEFT;
  }
  if (quantity === 2) {
    return translations.SPECIFIC_PRODUCT.ONLY_TWO_LEFT;
  }
  if (quantity === 1) {
    return translations.SPECIFIC_PRODUCT.ONLY_ONE_LEFT;
  }
  if (quantity === 0) {
    return translations.SPECIFIC_PRODUCT.OUT_OF_STOCK;
  }

  return translations.SPECIFIC_PRODUCT.IN_STOCK;
};
